<template>
  <aside class="simplify-hero-item">
    <span class="simplify-hero-item-header">
      <img
        loading="lazy"
        src="@/assets/images/check_small.svg"
        alt=""
        width="20px"
        height="20px"
      >
      <h2>{{ header }}</h2>
    </span>
    <slot>
      <span class="simplify-hero-item-paragraph">
        DEFAULT HERO ITEM DATA
      </span>
    </slot>
  </aside>
</template>

<script>
export default {
  name: 'SimplifyHeroItem',
  props: {
    header: {
      type: String,
      default: '',
      required: true,
    },
  },
};
</script>
